module.exports = __webpack_public_path__ + "img/同质化的产品生产.f327db07.png";